module.exports = __webpack_public_path__ + "static/img/discover.8a9df37.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/discover.jpg
// module id = 48jc
// module chunks = 0